/**
 * Returns the first non-empty URL from a semicolon-separated list (common in company registry / sheet exports).
 */
export function getFirstCompanyUrl(companyURL: string | undefined): string | null {
  if (!companyURL) return null;
  const urls = companyURL.split(';').map((u) => u.trim()).filter(Boolean);
  return urls.length > 0 ? urls[0]! : null;
}
